module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fullscreen-overlay-layout', {
    attrs: {
      "title": _vm.getCurrentRT.title
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    class: {
      'hidden-record': _vm.submission.is_hidden
    },
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('submission-card-header', {
    attrs: {
      "showHeaderOptions": false,
      "submission": _vm.submission
    }
  }), _vm._v(" "), _c('submission-response-text', {
    attrs: {
      "submission": _vm.submission,
      "shortenText": true,
      "smallFont": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "start-xs"
  }, [_c('span', {
    staticClass: "i",
    staticStyle: {
      "font-size": "12px",
      "color": "#273248"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.getPromptWordsLength) + " Words\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto mt3 tc relative"
  }, [_c('assessment-tab', {
    attrs: {
      "submission": _vm.submission
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-c486759e!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/individualAssessmentOverlay.vue
// module id = 1207
// module chunks = 61